











import { Component, Vue } from "vue-property-decorator";
import { deleteUserGroup } from "@/services/users/userGroupService";

    @Component
export default class UserGroupDeleteModal extends Vue {
        // local state
        groupToDeleteId: string = "";
        isSaved: boolean = false;

        // lifecycle hooks

        // computed

        // methods
        handleEnter(e: KeyboardEvent) {
            if (e.key === "Enter") this.confirmDelete();
        }

        removeEvent() {
            window.removeEventListener("keydown", this.handleEnter);
            this.isSaved = false;
        }

        open(userGroupId: string) {
            this.groupToDeleteId = userGroupId;
            this.$bvModal.show("modal-deleteUserGroup");
            window.addEventListener("keydown", this.handleEnter);
        }

        declineDelete() {
            this.groupToDeleteId = "";
            this.$bvModal.hide("modal-deleteUserGroup");
        }

        confirmDelete() {
            if (this.isSaved) return;
            this.isSaved = true;
            deleteUserGroup(this.groupToDeleteId).then(() => {
                this.$emit("reload");
                this.groupToDeleteId = "";
                this.$bvModal.hide("modal-deleteUserGroup");
            });
        }
}
